import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Home, ArrowExportRtl, AppRecent, Edit, Fingerprint, Guest } from 'styled-icons/fluentui-system-regular';
import { startLogout } from '../../redux/actions/_auth_actions';
import logo from '../../assets/img.png';
const Index = (props) => {
  const { className } = props;

  const dispatch = useDispatch();

  const uselocation = useLocation();

  const history = useHistory();

  const location = uselocation.pathname.split('t/')[1];

  const signOut = () => {
    dispatch(startLogout());
    history.push('/');
    // document.location.reload();
  };

  const navigation = (nav) => {
    history.push(nav);
  };

  return (
    <div className={className}>
      <img src={logo} className="logo" alt="" />
      <div className="divider" />
      <div
        className={location === 'dashboard' ? 'menuItemContainerActive' : 'menuItemContainer'}
        onClick={() => navigation('dashboard')}>
        <Home size={27} className="menuIcon" />
        <p>Dashboard</p>
      </div>
      <div
        className={location === 'adminusers' ? 'menuItemContainerActive' : 'menuItemContainer'}
        onClick={() => navigation('adminusers')}>
        <Guest size={27} className="menuIcon" />
        <p>Usuarios</p>
      </div>
      {
        <div
          className={location === 'blog' ? 'menuItemContainerActive' : 'menuItemContainer'}
          onClick={() => navigation('blog')}>
          <Edit size={27} className="menuIcon" />
          <p>Noticias</p>
        </div>
      }
      <div
        className={location === 'platform' ? 'menuItemContainerActive' : 'menuItemContainer'}
        onClick={() => navigation('platform')}>
        <Fingerprint size={27} className="menuIcon" />
        <p>Configuración</p>
      </div>
      {
        <div
          className={location === 'applications' ? 'menuItemContainerActive' : 'menuItemContainer'}
          onClick={() => navigation('applications')}>
          <AppRecent size={27} className="menuIcon" />
          <p>Postulaciones</p>
        </div>
      }
      <div className="logOutContainer" onClick={signOut}>
        <ArrowExportRtl size={27} className="menuIcon" color="#fff" />
        <p className="menuTitle" style={{ color: '#fff', fontFamily: 'Sofia Pro, sans-serif', fontSize: '.8rem' }}>
          Cerrar sesión
        </p>
      </div>
    </div>
  );
};

export default styled(Index)`
  width: auto;
  min-width: 155px;
  max-width: 155px;
  padding: 12px;
  //margin: 8px;
  position: fixed;
  display: flex;
  flex-direction: column;
  left: 0;
  height: 98vh;
  align-items: flex-start;
  top: 0;
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px;
  background-color: ${(props) => (props.adminColor ? props.adminColor : '#0f3f44')};
  overflow: auto;
  .logo {
    width: 80px;
    margin: 28px auto 32px auto;
  }
  .divider {
    display: flex;
    width: 80%;
    border-bottom: #eeeeee solid 2px;
    margin: 0px auto 76px;
    @media screen and (max-width: 800px) {
      margin: 0px auto 38px;
    }
  }
  .menuItemContainerActive {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    border-right: #fcd7e0 solid 4px;
    cursor: pointer;
    margin-bottom: 60px;
    p {
      font-family: 'Sofia Pro', sans-serif;
      font-size: 0.8rem;
      text-align: center;
      font-weight: 500;
      line-height: 32px;
      margin: 0px;
    }
    @media screen and (max-width: 800px) {
      margin-bottom: 20px;
    }
  }
  .menuItemContainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
    margin-bottom: 60px;
    p {
      font-family: 'Sofia Pro', sans-serif;
      font-size: 0.8rem;
      text-align: center;
      font-weight: 500;
      line-height: 32px;
      margin: 0px;
    }
    @media screen and (max-width: 800px) {
      margin-bottom: 20px;
    }
  }
  .menuIcon {
    font-size: 2.7rem;
    text-align: center;
  }
  .logOutContainer {
    margin-top: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .menuTitle {
    font-family: futura-pt;
    font-size: 1.2rem;
    text-align: center;
    font-weight: 500;
    line-height: 32px;
    margin: 0px;
  }
`;
